<template>
  <div class="page-content row" id="UserInvite">
    <div class="col s12 m11 main-page-content">

      <div class="col l3 sidebar hide-on-med-and-down">
        <div class="card">
          <user-info/>
        </div>

        <div class="card">
          <contact/>
        </div>

        <div class="card">
          <manual/>
        </div>

        <div class="card">
          <find-us/>
        </div>
      </div>


      <div v-if="isAgent" class="col s12 l9">
        <div class="card standard-card">
          <div class="share-info">
            <h4>Link do rejestracji dla współpracowników</h4>
            <p>
              Skopiuj link i wyślij do swoich współpracowników / agentów OFWCA, którzy będą dla Ciebie pracować.
            </p>
            <input-copy-url type="text" name="child_agent_registration_url"
                            label="Link do rejestracji dla współpracowników"
                            v-bind:value="child_agent_registration_url + getMpcCode"/>
          </div>
        </div>
      </div>

      <div class="col s12 l9">
        <div class="card highlighted-card">
          <h4>Jak to działa?</h4>
          <p>
            Każdy kto skutecznie poleci produkty Punkta otrzymuje wynagrodzenie.<br>
            <span class="bold">Rozpocznij zarabiać na ubezpieczeniach!</span> Dzięki naszym narzędziom i pomocy jest to
            proste i efektywne! Nie musisz posiadać wiedzy informatycznej ani ubezpieczeniowej, zajmiemy się wszystkim!
          </p>

          <br>
          <div class="cooperation-steps">
            <div class="line hide-on-small-only"></div>

            <div class="step">
              <div class="circle" number="1">
                <img class="inside-circle" src="../../assets/copy.svg" alt='email wysłany'>
              </div>
              <div class="circle-text">
                <h5 class="key-words">Skopiuj link do produktu</h5>
              </div>
            </div>

            <div class="step">
              <div class="circle" number="2">
                <img class="inside-circle" src="../../assets/znajomi_icon.svg" alt='email wysłany'>
              </div>
              <div class="circle-text">
                <h5 class="key-words">Promuj i polecaj</h5>
              </div>
            </div>

            <div class="step last-step">
              <div class="circle last-circle" number="3">
                <img class="inside-circle" src="../../assets/wyplac_icon.svg" alt='email wysłany'>
              </div>
              <div class="circle-text">
                <h5 class="key-words">Otrzymuj wynagrodzenie</h5>
              </div>
            </div>
          </div>
        </div>

        <div class="card standard-card">
          <div class="share-info">
            <h4>Link do produktu</h4>
            <p v-if="isAnyAgent">
              Skopiuj link i zacznij promować porównywarkę ubezpieczeń komunikacyjnych Punkta.
            </p>
            <p v-else>
              Skopiuj link i zacznij promować porównywarkę ubezpieczeń komunikacyjnych Punkta na swojej stronie
              internetowej, blogu, Youtube, Facebook oraz bazie mailingowej.
            </p>
            <input-promo-url type="text" name="promo_url" label="Kod do promowania"/>
            <calculate-button/>
          </div>
        </div>

        <div class="card standard-card">
          <div class="share-info">
            <h4>Widget punkta</h4>
            <p v-if="isAnyAgent">
              Jeżeli masz swoją stronę Internetową skopiuj poniższy kod i wklej na stronę.
            </p>
            <p v-else>
              Skopiuj poniższy kod i wklej na swoją stronę.<br/>Wszystkie kalkulacje oraz opłacone polisy
              będą automatycznie zliczane i&nbsp;prezentowane w
              <router-link :to="{ name: 'yourFunds' }">profilu partnerskim</router-link>
              .
            </p>
            <textarea-promo-widget name="promo_widget"/>
          </div>
        </div>

        <Banners/>

      </div>
    </div>
  </div>
</template>

<script>
import FindUs from '@/components/findUs'
import Contact from '@/components/contact'
import Manual from '@/components/manual/manual'
import UserInfo from '@/components/userInfo'
import {userHasRole, userHasAnyOfRoles} from '@/services/helper'
import InputPromoUrl from '@/components/inputs/promoUrl'
import Banners from '@/components/banners/banners'
import InputCopyUrl from '@/components/inputs/copyUrl'
import TextareaPromoWidget from '@/components/inputs/promoWidget'
import CalculateButton from '../../components/calculateButton.vue'
import {mapGetters} from 'vuex'

export default {
  components: {UserInfo, FindUs, Banners, InputPromoUrl, InputCopyUrl, TextareaPromoWidget, Manual, Contact, CalculateButton},
  name: 'UserInvite',
  computed: {
    ...mapGetters(['getUserRoles', 'getMpcCode']),
    isAgent () {
      return userHasRole(this.getUserRoles, 'agent')
    },
    isAnyAgent () {
      const agentRoles = ['agent', 'agent_level2']
      return userHasAnyOfRoles(this.getUserRoles, agentRoles)
    }
  },
  beforeMount () {
    this.$store.dispatch('promoCode', 'get')
  },
  data () {
    const root = window.location.origin
    return {
      child_agent_registration_url: `${root}/rejestracja-agenta?parent_mpc_code=`
    }
  }
}
</script>

<style lang="scss" src="./userInvite.scss"></style>



// WEBPACK FOOTER //
// userInvite.vue?c60d62f0